import serviceGroupHasService from '../serviceGroupHasService';

const isQuoteLongDistance = ({ service_groups: serviceGroups }: any) => {
  // Will have gaps in future as more quotes may be added to booking flow
  // Perfect solution would be to duplicate long distance logic from headquarters-ui
  // Using combination of mileage, partner id, and markets

  const hasSingleLabor = serviceGroups?.some(
    (serviceGroup) =>
      serviceGroupHasService(serviceGroup, 'LOADING') ||
      serviceGroupHasService(serviceGroup, 'LDLOADING') ||
      serviceGroupHasService(serviceGroup, 'UNLOADING') ||
      serviceGroupHasService(serviceGroup, 'LDUNLOADING'),
  );
  const hasTransit = serviceGroups?.some(
    (serviceGroup) => serviceGroupHasService(serviceGroup, 'TRANSIT') || serviceGroupHasService(serviceGroup, 'LDTRANSIT'),
  );
  if (hasSingleLabor && hasTransit) return true;
  return false;
};

export default isQuoteLongDistance;
